import '../../style/index.less'
import './index.less'



// WEBPACK FOOTER //
// ./components/rate/style/index.js